import React from 'react'
import { useTranslation } from 'react-i18next'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { setModal } from '../../../../app/store/reducers/AppSlice'
import { EditAffiliateModal } from '../../widgets/edit-affiliate-modal/EditAffiliateModal'

interface EditAffiliateCellProps {
  publisher_id: number
}

export const EditAffiliateCell = ({ publisher_id }: EditAffiliateCellProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <div className='flex w-full justify-end'>
      <BpButton
        size='sm'
        theme='outline'
        onClick={() =>
          dispatch(setModal({ children: <EditAffiliateModal publisherId={publisher_id} /> }))
        }
      >
        {t('buttons.editAffiliate')}
      </BpButton>
    </div>
  )
}
